import { repeat, padEnd } from 'lodash'
import * as FileSaver from 'file-saver'
import { format } from 'date-fns/esm'

export function generateDPAE (contrat) {
  var entete = '00000000000000DUE                U                                   912' +// ENTETE 77 char
  '120' +// C_VERSION TST pour message de test, 120 exploitataion
  repeat(' ', 2)

  var dpae = 'WEBDUE      CONTRAT IADE CABINET            ' + // zone libre, champs 78->121, 44 char
    repeat(' ', 12) +
    '827' + // code urssaf rhone alpes C_URSSAF
    '48887447000021' + // SIRET
    ' ' +
    padEnd('SCM CAB ANESTHESIE DES CEDRES', 32, ' ') + // L_RAISON_SOC_1 32 char
    repeat(' ', 4) +
    padEnd('CABINET D ANESTHESIE', 32, ' ') + // L_ADR_EMP_1 32 char
    padEnd('48 AVENUE DE GRUGLIASCO', 32, ' ') + // L_ADR_EMP_2 32 char
    '38130' + // C_POSTAL_EMP
    padEnd('ECHIROLLES', 27, ' ') +
    padEnd(contrat.interimaireByInterimaireId.nom.toUpperCase(), 32, ' ') +// L_NOM_PATRO_SAL
    padEnd(contrat.interimaireByInterimaireId.prenom.toUpperCase(), 32, ' ') +// L_PRENOMS_SAL
    contrat.interimaireByInterimaireId.numss +// N_SECU_SOC
    format(new Date(contrat.interimaireByInterimaireId.dateNaiss), 'ddMMyyyy') +// D_NAISSANCE_SAL
    padEnd(contrat.interimaireByInterimaireId.lieuNaiss.toUpperCase(), 24, ' ') +// L_LIEU_NAISS_SAL
    repeat(' ', 20) +
    format(new Date(contrat.dateDebut), 'ddMMyyyy') +// D_EMBAUCHE
    format(new Date(contrat.dateDebut), 'HHmm') +// H_EMBAUCHE
    // Srepeat('x', 4) +
    repeat(' ', 5) +
    repeat(' ', 2)

  var employeur = repeat(' ', 78) +
    padEnd('SCM CAB ANESTHESIE DES CEDRES', 32, ' ') +// L_RAISON_SOC_2
    padEnd('0456581250', 11, ' ') +// N_TEL_EMP
    repeat(' ', 107) +
    'U' +
    '6619A' +// C_NAF_NN
    repeat(' ', 33)

  var salarie = padEnd(contrat.interimaireByInterimaireId.nom.toUpperCase(), 32, ' ') +// L_NOM_EPOUX_SAL
    (contrat.interimaireByInterimaireId.lieuNaiss === 'Monsieur' ? 'M' : 'F') +// C_SEXE_SAL
    repeat(' ', 96) +
    contrat.interimaireByInterimaireId.departementNaiss +// C_DEPT_NAISS_SAL 2char
    repeat(' ', 35)

  var con = '1' +// C_TYPE_CONTRAT Code type de contrat (1, 2, 3) pour CDI CDD CTT
      format(new Date(contrat.dateFin), 'ddMMyyyy') +// D_FIN_CDD
      repeat(' ', 11) +
      '000' +// N_JJ_ESSAI
      repeat(' ', 50) +
      'MT547' +// C_MT_DCL TODO: a preciser
      repeat(' ', 23)

  var formalites = repeat(' ', 19)

  var blob = new Blob([entete +
                       dpae +
                       employeur +
                       salarie +
                       con +
                       formalites +
                       '\n'], {type: 'text/plain;charset=utf-8'})
  // console.log('blob', blob.length)
  FileSaver.saveAs(blob, `dpae-${contrat.interimaireByInterimaireId.nom}-${format(new Date(), 'ddMMyyyyHmm')}.txt`)
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/dpae.js